import { render, staticRenderFns } from "./ChatMessageInput.vue?vue&type=template&id=c37a4386"
import script from "./ChatMessageInput.vue?vue&type=script&lang=js"
export * from "./ChatMessageInput.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageInput.vue?vue&type=style&index=0&id=c37a4386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports